import * as React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import cx from 'classnames';
import style from './Nav.css';

import LineAbout from './icons/about.inline.svg';
import LineContact from './icons/contact.inline.svg';
import LineResources from './icons/resources.inline.svg';
import LineTeam from './icons/team.inline.svg';

export const Nav = ({className, onClick}) => (
    <nav className={cx(style.root, className)}>
        <ul className={style.list}>
            <li className={style.item}>
                <NavLink
                    exact
                    to="/history"
                    className={style.link}
                    activeClassName={style.active}
                    onClick={onClick}
                >
                    HISTORY
                    <LineAbout className={style.line}/>
                </NavLink>
            </li>
            <li className={style.item}>
                <NavLink
                    to="/team"
                    className={style.link}
                    activeClassName={style.active}
                    onClick={onClick}
                >
                    TEAM
                    <LineTeam className={style.line}/>
                </NavLink>
            </li>
            <li className={style.item}>
                <NavLink
                    to="/resources"
                    className={style.link}
                    activeClassName={style.active}
                    onClick={onClick}
                >
                    RESOURCES
                    <LineResources className={style.line}/>
                </NavLink>
            </li>
            <li className={style.item}>
                <NavLink
                    to="/contact"
                    className={style.link}
                    activeClassName={style.active}
                    onClick={onClick}
                >
                    CONTACT
                    <LineContact className={style.line}/>
                </NavLink>
            </li>
            <li className={style.item}>
                <a
                    href="https://blockscience.ghost.io/"
                    target="_blank"
                    className={style.link}
                >
                    BLOG
                    <LineResources className={style.line}/>
                </a>
            </li>
            <li className={style.item}>
                <a
                    href="http://cadcad.org"
                    target="_blank"
                    className={style.link}
                >
                    cadCAD
                    <LineResources className={style.line}/>
                </a>
            </li>
            {/* <li className={style.item}>
                <a
                    href="https://blocksciencelabs.com"
                    target="_blank"
                    className={style.link}
                >
                    LABS
                    <LineResources className={style.line}/>
                </a>
            </li> */}
        </ul>
    </nav>
);

Nav.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
};

Nav.defaultProps = {
    onClick: () => {}
};